import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const initialState = {
  versions: [],
  appVersion: null,
  features: {
    app: null,
    dev: null,
    demo: null
  }
}

export default {
  state: { ...initialState },
  actions,
  getters,
  mutations
}
